import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  ConnectionAckServerMessage_instance2m47rw1rcdnts as ConnectionAckServerMessage_instance,
  PingServerMessage_instance3gqk60x9xj12k as PingServerMessage_instance,
  PongServerMessage_instancew68t57iujoli as PongServerMessage_instance,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
} from './ServerMessage.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toClientMessage6qtheyrb1jpy as toClientMessage } from './ClientMessage.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  toRequestParameters3ovu7e0943da8 as toRequestParameters,
  toMap14rbdrx2whbk6 as toMap,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/RequestParameters.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import {
  jsonReaderkr2c3w0efm9b as jsonReader,
  readAny17j2jqaxubdko as readAny,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      parseServerMessage_w2if7h_k$(map) {
        var tmp = map.get_wei43m_k$('type');
        var type = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        if (type == null) {
          return new (ParseErrorServerMessage())("No 'type' found in server message: '" + toString(map) + "'");
        }
        var tmp_0;
        switch (type) {
          case 'connection_ack':
            tmp_0 = ConnectionAckServerMessage_instance;
            break;
          case 'ping':
            tmp_0 = PingServerMessage_instance;
            break;
          case 'pong':
            tmp_0 = PongServerMessage_instance;
            break;
          case 'next':
          case 'complete':
          case 'error':
            var tmp_1 = map.get_wei43m_k$('id');
            var id = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null;
            if (type === 'next') {
              return new (ResponseServerMessage())(toString_0(id), map.get_wei43m_k$('payload'));
            }

            var tmp_2;
            if (id == null) {
              tmp_2 = new (ParseErrorServerMessage())("No 'id' found in message: '" + toString(map) + "'");
            } else if (type === 'next') {
              tmp_2 = new (ResponseServerMessage())(id, map.get_wei43m_k$('payload'));
            } else if (type === 'complete') {
              tmp_2 = new (CompleteServerMessage())(id);
            } else if (type === 'error') {
              tmp_2 = new (OperationErrorServerMessage())(id, map.get_wei43m_k$('payload'));
            } else {
              // Inline function 'kotlin.error' call
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(''));
            }

            tmp_0 = tmp_2;
            break;
          default:
            tmp_0 = new (ParseErrorServerMessage())("Unknown type: '" + type + "' found in server message: '" + toString(map) + "'");
            break;
        }
        return tmp_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function GraphQLWsProtocol$_init_$slambda_rjuq6n() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
var GraphQLWsProtocolClass;
function GraphQLWsProtocol() {
  if (GraphQLWsProtocolClass === VOID) {
    class $_0 {
      constructor(connectionPayload) {
        var tmp;
        if (connectionPayload === VOID) {
          tmp = GraphQLWsProtocol$_init_$slambda_rjuq6n();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        this.connectionPayload_1 = connectionPayload;
      }
      get_name_woqyms_k$() {
        return 'graphql-transport-ws';
      }
      *connectionInit_8t0fah_k$($completion) {
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        map.put_4fpzoq_k$('type', 'connection_init');
        var payload = yield* $(this.connectionPayload_1($completion), $completion);
        if (!(payload == null)) {
          map.put_4fpzoq_k$('payload', payload);
        }
        return toClientMessage(map);
      }
      *operationStart_u0u3fg_k$(request, $completion) {
        return toClientMessage(mapOf([to('type', 'subscribe'), to('id', request.requestUuid_1.toString()), to('payload', toMap(toRequestParameters(request)))]));
      }
      operationStop_jpn5al_k$(request) {
        return toClientMessage(mapOf([to('type', 'complete'), to('id', request.requestUuid_1.toString())]));
      }
      ping_21r3m_k$() {
        return toClientMessage(mapOf_0(to('type', 'ping')));
      }
      pong_21vjs_k$() {
        return toClientMessage(mapOf_0(to('type', 'pong')));
      }
      parseServerMessage_f93uyf_k$(text) {
        var tmp;
        try {
          var tmp_0 = readAny(jsonReader((new (Buffer())()).writeUtf8_9rv3au_k$(text)));
          tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KtMap()) : false) ? tmp_0 : THROW_CCE();
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var _unused_var__etf5q3 = $p;
            return new (ParseErrorServerMessage())("Invalid JSON: '" + text + "'");
          } else {
            throw $p;
          }
        }
        var map = tmp;
        return Companion_instance.parseServerMessage_w2if7h_k$(map);
      }
    }
    initMetadataForClass($_0, 'GraphQLWsProtocol', GraphQLWsProtocol, VOID, VOID, [0, 1]);
    GraphQLWsProtocolClass = $_0;
  }
  return GraphQLWsProtocolClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  GraphQLWsProtocol as GraphQLWsProtocol3nqe2321ot0cb,
};
//endregion

//# sourceMappingURL=GraphQLWsProtocol.mjs.map
